/**
 * Filters the menu based on authentication status and other conditions.
 * @param {Array} menu - The menu array to filter.
 * @param {string|null} token - The authentication token.
 * @returns {Array} - The filtered menu array.
 */
export const filteredMenu = (menu, token) => {
  return menu.filter((item) => {
    if (item.isProtected && !token) {
      return false; // Hide protected items if the user is not authenticated
    }
    if (item.onlyNonAuth && token) {
      return false; // Hide items meant only for non-authenticated users if the user is logged in
    }
    return true; // Show other items
  });
};
